module.exports = __webpack_public_path__ + "media/images/emoticons/mist-faa380a8df2e7cbdd1a45488e5d1c219.gif";